import { gql } from "@apollo/client"

export const GET_PEOPLE_WITH_SESSION_COUNT = gql`
query getPeopleWithSessionCount($companyId:UUID, $locationId:UUID,$query:String,$first:Int, $after:String) {
  personStatsPerCompany (companyId:$companyId,locationId:$locationId, query:$query, first:$first, after:$after){
   pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
    edges{
    node{
    id
    firstName
    middleName
    lastName
    expired
    email
    jobTitle
    startDate
    endDate
    role{
      clientFacingName
      name
      normalizedName
    }
    workLists{
      status
    }
    singleStudents{
        id
        firstName
        lastName
        locationId
        references
    }
    totalCompleteSessions
    lastRunSession
    locations {
      edges{
        node{
          id
          name
          }
        }
      }}}
  }
}
`